import { createContext, useContext } from "react";
import { AuthStore } from "./authStore";
import { DiscoverStore } from "./discoverStore";
import { ExploreStore } from "./exploreStore";
import { WalletStore } from "./walletStore";
import { FriendsStore } from "./friendsStore";
import { DmStore } from "./dmStore";
import { NotificationStore } from "./notificationStore";
import { UiStore } from "./uiStore";
import { runInAction } from "mobx";
import type { PageData } from "../ssr/data";

export interface RootStore {
	auth: AuthStore;
	discover: DiscoverStore;
	explore: ExploreStore;
	wallet: WalletStore;
	friends: FriendsStore;
	dm: DmStore;
	notification: NotificationStore;
	ui: UiStore;
}

export function applyPageData(store: RootStore, page: PageData) {
	runInAction(() => {
		store.auth.user = page.session.user;
		store.auth.ageRestricted = page.session.ageRestricted;
		store.auth.initialized = true;
		store.ui.theme = page.theme;
		if (page.discover) store.discover.seed(page.discover, page.session.user?.id ?? null, page.locale);
		if (page.explore) store.explore.seed(page.explore, page.locale, page.session.user?.id ?? null);
	});
}

export function createRootStore(page?: PageData): RootStore {
	const store = { auth: new AuthStore(), discover: new DiscoverStore(), explore: new ExploreStore(), wallet: new WalletStore(), friends: new FriendsStore(), dm: new DmStore(), notification: new NotificationStore(), ui: new UiStore() };
	if (page) applyPageData(store, page);
	return store;
}

export const StoreContext = createContext<RootStore | null>(null);

export function useStore(): RootStore {
	const store = useContext(StoreContext);
	if (!store) throw new Error("StoreProvider is required");
	return store;
}
